import React from "react";
import { Link } from "react-router-dom";

const NotFound: React.FC = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50 text-center p-4">
      <h1 className="text-6xl sm:text-8xl font-bold text-red-600 mb-4">404</h1>
      <p className="text-lg sm:text-xl text-gray-600 mb-6">
        Oops! Pagina pe care o căutați nu există.
      </p>
      <Link
        to="/"
        className="text-lg sm:text-xl font-semibold text-blue-500 hover:text-blue-700"
      >
        Înapoi la pagina principală
      </Link>
    </div>
  );
};

export default NotFound;
